<div class="forum-thread-reaction-users-modal">
  <div class="mb-4">
    <h4>{{ "GROUPS.LIST.THREAD_REACTION_MODAL_TITLE" | translate }}</h4>
  </div>

  <div
    class="forum-thread-reaction-users-modal__list d-flex flex-column gap-24"
  >
    <div
      *ngFor="let user of data.users; trackBy: trackByUserId"
      class="d-flex align-items-center justify-content-between gap-16"
    >
      <div class="d-flex align-items-center gap-16">
        <div class="forum-thread-reaction-users-modal__avatar">
          {{
            getUserNameParts(user.name).firstName
              | initials: getUserNameParts(user.name).lastName
          }}
          <span class="forum-thread-reaction-users-modal__emoji">
            {{ data.emoji | forumReactionEmoji }}
          </span>
        </div>

        <div>
          <h6>
            {{ user.name }}
          </h6>
          <p class="text-body-sm color-bg-text-muted">
            {{ user.email }}
          </p>
        </div>
      </div>

      <round-button
        *ngIf="!!data.currentUserId && user.id === data.currentUserId"
        [matTooltip]="'GROUPS.EDIT.DELETE_BUTTON' | translate"
        set="lucide"
        icon="trash-2"
        (click)="deleteReaction($event)"
      />
    </div>
  </div>
</div>
